import Vue from 'vue'

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import VueGtag from "vue-gtag";
import it from "vee-validate/dist/locale/it.json";
import * as rules from "vee-validate/dist/rules";
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
localize("it", it);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
import '@/mixins/helper';
import { loadRecaptcha } from '@/config/recaptcha';
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta';
import { BootstrapVue } from 'bootstrap-vue';
import VueCookies from 'vue-cookies';

Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../../assets/css/style.css'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
Vue.use(VueMeta);

Vue.use(VueCookies);
Vue.config.productionTip = false

// Carica reCAPTCHA v3 all'avvio: se lo script non e' raggiungibile
// il tool resta comunque utilizzabile, il token sara' semplicemente nullo.
loadRecaptcha().catch(error => console.log('recaptcha', error));

if(process.env.VUE_APP_WEB_PATH === 'https://www.asteaenergia.it/wp/') {
  Vue.use(VueGtag, {
    config: { id: "G-2RG3Q9LVWL" }
  });

}

Number.prototype.pad = function(n) {
  return new Array(n).join('0').slice((n || 2) * -1) + this;
}
Number.prototype.formatNumber = function() {
  let val = (this/1).toFixed(0).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
